import { useState } from 'react';
import {
  Container,
  Typography,
  TextField,
  Button,
  Box,
  Alert,
  CircularProgress,
  Grid,
  Fade
} from '@mui/material';
import Info from './Info';
import { useAdminLanguage } from './AdminI18n';

function AdminAccess() {
  const { t } = useAdminLanguage();
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword1, setNewPassword1] = useState('');
  const [newPassword2, setNewPassword2] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    if (newPassword1 !== newPassword2) {
      setError('Les nouveaux mots de passe ne correspondent pas.');
      setLoading(false);
      return;
    }

    try {
      const token = sessionStorage.getItem('authToken');
      if (!token) {
        setError('Authentification requise.');
        setLoading(false);
        return;
      }

      const response = await fetch('/api/access', {
        method: 'PUT',
        headers: { 
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ oldPassword, newPassword1, newPassword2 }),
      });

      if (response.ok) {
        setSuccess('Mot de passe mis à jour avec succès.');
        setOldPassword('');
        setNewPassword1('');
        setNewPassword2('');
      } else {
        const data = await response.json();
        setError(data.error || 'Une erreur est survenue lors de la mise à jour du mot de passe.');
      }
    } catch (error) {
      setError('Une erreur est survenue lors de la communication avec le serveur.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Fade in timeout={500}>
        <Box>
          <Typography
            variant="h4"
            gutterBottom
            align="center"
            color="primary"
            sx={{ fontWeight: 'bold', mb: 4 }}
          >
            {t("Changer le mot de passe d'administration")}
          </Typography>

          <Info type="access" />

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {t(error)}
            </Alert>
          )}

          {success && (
            <Alert severity="success" sx={{ mb: 2 }}>
              {t(success)}
            </Alert>
          )}

          <Box component="form" onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label={t('Mot de passe actuel')}
                  type="password"
                  value={oldPassword}
                  onChange={(e) => setOldPassword(e.target.value)}
                  required
                  variant="outlined"
                  disabled={loading}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label={t('Nouveau mot de passe')}
                  type="password"
                  value={newPassword1}
                  onChange={(e) => setNewPassword1(e.target.value)}
                  required
                  variant="outlined"
                  disabled={loading}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label={t('Confirmer le nouveau mot de passe')}
                  type="password"
                  value={newPassword2}
                  onChange={(e) => setNewPassword2(e.target.value)}
                  required
                  variant="outlined"
                  disabled={loading}
                />
              </Grid>
              <Grid item xs={12}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  fullWidth
                  disabled={loading}
                  startIcon={loading && <CircularProgress size={20} />}
                  sx={{
                    py: 1.5,
                    fontSize: '1rem',
                    textTransform: 'none',
                    transition: 'all 0.3s',
                    '&:hover': { boxShadow: 6 },
                    maxWidth: '300px',
                    mx: 'auto',
                    display: 'block',
                  }}
                >
                  {loading ? t('Enregistrement...') : t('Enregistrer')}
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Fade>
    </Container>
  );
}

export default AdminAccess;